import cn from 'clsx';
import React from 'react';

import { Button, Heading1, Heading2, Heading4, Image, useDeviceType } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';
import { Breadcrumbs, IBreadcrumbNavItem } from '../Breadcrumbs';
import { ContainerInner } from '../ContainerInner';
import { FeatureHighlightList } from '../FeatureHighlightList';
import Logo from './logo.png';
import styles from './styles.css';

const STEPS = [
  { title: 'Выберите банки', description: `Рассчитайте и${NBSP}выберите выгодные${NBSP}предложения` },
  { title: 'Заполните анкету', description: 'Займёт 5–7 минут' },
  { title: 'Ожидайте одобрения', description: `Позвоним или пришлём смс в${NBSP}течение${NBSP}24${NBSP}часов` },
  { title: 'Оформите сделку', description: `Мы${NBSP}будем рядом на каждом этапе` },
];

interface INewPresentationBlockProps {
  breadcrumbs: IBreadcrumbNavItem[];
  onCtaClick: () => void;
}

export const NewPresentationBlock: React.FC<INewPresentationBlockProps> = ({ onCtaClick, breadcrumbs }) => {
  const deviceType = useDeviceType();

  const Subtitle = deviceType === 'desktop' ? Heading2 : Heading4;

  const hasBreadcrumbs = breadcrumbs.length > 1;

  const items = STEPS.map((step, index) => ({
    ...step,
    bullet: <Heading1 fontWeight="500">{index + 1}</Heading1>,
  }));

  return (
    <ContainerInner>
      <div className={cn(styles['container'], styles[deviceType], hasBreadcrumbs && styles['with-breadcrumbs'])}>
        {hasBreadcrumbs && (
          <div className={cn(styles['breadcrumbs-container'], styles[deviceType])}>
            <Breadcrumbs
              items={breadcrumbs.map((item, index) =>
                index === 0 ? { ...item, color: 'text-secondary-disabled' } : item,
              )}
            />
          </div>
        )}
        <div className={cn(styles['main'], styles[deviceType])}>
          <div className={styles['logo']}>
            {/* TODO: временно костыль, в другой задаче перенесу в CDN все картинки */}
            <Image src={Logo} height={120} objectFit="contain" />
          </div>
          <div className={cn(styles['content'], styles[deviceType])}>
            <div className={cn(styles['title'], styles[deviceType])}>
              <Heading1 fontWeight="700">Подберите ипотеку</Heading1>
            </div>
            <Subtitle color="text-secondary-default" fontWeight="700">
              Покажем{NBSP}предложения, подходящие{NBSP}именно{NBSP}вам
            </Subtitle>
          </div>
          <div className={styles['cta']}>
            <Button size="L" onClick={onCtaClick} data-testid={ETestIds.PresentationBtn}>
              Подобрать
            </Button>
          </div>
        </div>
        <div className={cn(styles['highlights'], styles[deviceType])}>
          <FeatureHighlightList items={items} />
        </div>
      </div>
    </ContainerInner>
  );
};
